import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import "./_style.scss"

const RulerTitle = React.lazy(() => import("§/src/components/atoms/title/ruler-title"))
const Downloader = React.lazy(() => import("§/src/components/sections/downloader"))
const SliderSimple = React.lazy(() => import("§/src/components/sections/slider-simple/slider-simple.js"))
const SliderCard = React.lazy(() => import("§/src/components/sections/slider-card/slider-card.js"))
const TextIcons = React.lazy(() => import("§/src/components/sections/text-icons"))
const TextIconsGrid = React.lazy(() => import("§/src/components/sections/text-iconsgrid"))
const NumbersGrid = React.lazy(() => import("§/src/components/sections/numbers-grid"))
const VideoFull = React.lazy(() => import("§/src/components/sections/video-full"))
const VideoTileSlider = React.lazy(() => import("§/src/components/sections/video-tile-slider"))
const TextTabs = React.lazy(() => import("§/src/components/sections/text-tabs"))
const HeroText = React.lazy(() => import("§/src/components/sections/hero-text"))
const TextModule = React.lazy(() => import("§/src/components/atoms/content/text-module"))
const TextImage = React.lazy(() => import("§/src/components/atoms/content/text-image"))
const TextImageSlider = React.lazy(() => import("§/src/components/sections/editorial-content/notes.js"))
const ListedArticles = React.lazy(() => import("§/src/components/sections/editorial-content/articles.js"))
const Hero = React.lazy(() => import("§/src/components/sections/hero"))
const Charts = React.lazy(() => import("§/src/components/sections/charts"))
const LayouterCustomBlock = React.lazy(() => import("§/src/components/sections/layouter-custom-block"))


const Layouter = ({ data, customData, ...props }) => {
  const compClassName = "layouter"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  return (
    <React.Suspense fallback="Loading...">
      <div comp={compClassName} className={compClass}>
        {data &&
          data.map((item, index) => {
            return (
              <React.Fragment key={"layouter-" + index}>
                {item?.fieldGroupName?.endsWith("_SliderSimple") && (
                  <SliderSimple
                    slider={item?.slider}
                    className={"mb-7 mb-md-9"}
                    key={"hero-text-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_SliderCard") && (
                  <SliderCard
                    sectiontitle={<RulerTitle title={item?.title} />}
                    slider={item?.slides}
                    className={"mb-7 mb-md-9"}
                    key={"hero-text-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_HeroTextBlock") && (
                  <HeroText
                    background={item?.background}
                    pretitle={item?.pretitle}
                    title={item?.title}
                    description={item?.subtitle}
                    titletag={item?.titleTag}
                    key={"hero-text-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_HeroImageBlock") && (
                  <GatsbyImage
                    image={getImage(item?.compHeroImage)}
                    alt={item?.compHeroImage?.altText}
                    className={"mb-7 mb-md-9 hero-image"}
                    key={"hero-image-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_VideoBlock") && item?.compVideo?.[0] && (
                  <VideoFull
                    data={item?.compVideo[0]}
                    className={"padded mb-7 mb-md-9"}
                    key={"video-image-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_VideoTileSliderBlock") && (
                  <VideoTileSlider
                    data={item}
                    className={"padded mb-7 mb-md-9"}
                    key={"video-tiles-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_DownloaderBlock") && (
                  <Downloader
                    title={item?.downloadTitle}
                    data={item?.downloadFiles}
                    orientation={item?.orientation}
                    className={"padded mb-7 mb-md-9"}
                    key={"downloader-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_TextIconsGridBlock") && (
                  <TextIconsGrid
                    title={item?.title}
                    image={item?.image}
                    background={item?.background}
                    gridtitle={item?.textIconsTitle}
                    data={item?.textIconsGrid}
                    className={"mb-7 mb-md-9 " + item?.background}
                    key={"text-icons-grid-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_TextIconsBlock") && (
                  <TextIcons
                    background={item?.background}
                    data={item?.textIcons ? item.textIcons[0] : ''}
                    column1Title={item?.column1Title}
                    column2Title={item?.column2Title}
                    mobileTitle={item?.mobileTitle}
                    list={item?.list}
                    blockId={item?.blockId}
                    className="mb-4"
                    key={"text-icons-grid-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_ListedArticlesBlock") && (
                  <ListedArticles
                    articles={item?.listedArticles}
                    title={item?.listedArticlesTitle}
                    className={"mb-7 mb-md-9"}
                    key={"listed-articles-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_EditorialBannerBlock") && item?.compHero?.[0] && (
                  <Hero
                    data={item?.compHero}
                    className={"mb-7 mb-md-9"}
                    key={"editorial-banner-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_TextModuleBlock") && (
                  <TextModule
                    from={props?.from}
                    pretitle={item?.preTitle}
                    title={item?.title}
                    titleImage={item?.titleImage}
                    content={item?.content}
                    cta={item?.cta}
                    orientation={item?.textModuleOrientation}
                    template={item?.template}
                    positionInBundle={item?.positionInBundle}
                    downloadstitle={item?.downloads?.title}
                    downloadsfiles={item?.downloads?.downloadFiles}
                    twotilesandimage={item?.twoTilesAndImage}
                    reports={item?.reports}
                    className={"pb-7 pb-md-9"}
                    key={"text-module-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_NumbersGridBlock") && (
                  <NumbersGrid
                    sectionTitle={item?.sectionTitle}
                    items={item?.numberTiles}
                    className={"mb-7 mb-md-9"}
                    key={"numbersgrid-module-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_TextImageBlock") && (
                  <TextImage
                    template={item?.template}
                    disposition={item?.disposition}
                    quote={item?.quote}
                    texttitle={item?.textTitle}
                    textcontent={item?.textContent}
                    type={item?.type}
                    image={item?.image}
                    imagemobile={item?.imageMobile}
                    className={"mb-7 mb-md-9"}
                    key={"text-image-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_TextImageSliderBlock") && (
                  <TextImageSlider
                    data={item}
                    notes={item?.textImageSlider}
                    className={"mb-7 mb-md-9"}
                    layouter={true}
                    key={"text-image-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_TextTabsBlock") && (
                  <TextTabs
                    data={item?.textTabs}
                    title={item?.textTabsTitle}
                    template={item?.template}
                    className={"mb-7 mb-md-9"}
                    key={"text-tabs-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_ChartBlock") && (
                  <Charts
                    chartTitle={item?.chartTitle}
                    titlePosition={item?.titlePosition}
                    content={item?.content}
                    compChart={item?.compChart}
                    className={"mb-7 mb-md-9"}
                    key={"chart-" + index}
                  />
                )}
                {item?.fieldGroupName?.endsWith("_CustomBlock") && (
                  <LayouterCustomBlock
                    sectionTitle={item?.customBlockTitle}
                    id={item?.customBlockId}
                    type={item?.customBlockType}
                    customData={customData}
                    key={"layouter-custom-block-" + index}
                  />
                )}
              </React.Fragment>
            )
          })}
      </div>
    </React.Suspense>
  )
}

export default Layouter
